import React from "react";
var __jsx = React.createElement;
import { useEffect } from 'react';
function StylesParallax() {
  useEffect(function () {
    import('swiper/css/parallax', {
      assert: {
        type: 'css'
      }
    });
  }, []);
  return __jsx(React.Fragment, null);
}
export default StylesParallax;